class ConnectivityManager {
  constructor() {
    this.isOnline = true;
    this.listeners = [];
    this._heartbeatTimer = null;
    this._apiBase = null;

    window.addEventListener('online',  () => this._ping());
    window.addEventListener('offline', () => this.setOnline(false, 'browser-offline'));
  }

  setApiBase(url) {
    this._apiBase = url;
  }

  async _ping() {
    if (!this._apiBase) return;
    try {
      const ctrl = new AbortController();
      const t = setTimeout(() => ctrl.abort(), 6000);
      const token = localStorage.getItem('token') || '';
      const res = await fetch(`${this._apiBase}/api/health`, {
        method: 'GET',
        cache: 'no-store',
        signal: ctrl.signal,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      clearTimeout(t);
      if (res.ok) this.setOnline(true, 'heartbeat');
    } catch {}
  }

  setOnline(online, event) {
    if (this.isOnline === online) return;
    this.isOnline = online;
    const ev = event || (online ? 'reconnected' : 'disconnected');
    console.log(`[connectivity] ${online ? 'ONLINE' : 'OFFLINE'} (${ev})`);
    this.listeners.forEach(cb => cb({ online, event: ev }));
    // When offline: start pinging every 15s to auto-recover
    clearInterval(this._heartbeatTimer);
    if (!online) {
      this._heartbeatTimer = setInterval(() => this._ping(), 15000);
    }
  }

  subscribe(callback) {
    this.listeners.push(callback);
    return () => { this.listeners = this.listeners.filter(cb => cb !== callback); };
  }
}

const connectivity = new ConnectivityManager();
export default connectivity;
